import React from "react";
import { getDate } from "utils/formatDate";
import Pagination from "react-js-pagination";
import { formatNumber } from "utils/currencyFormat";

class LichSuHopDongView extends React.Component {
  constructor(props) {
    super(props);
    let isShow = true;
    let displayText = "contents";
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = !mq.matches;
      if (mq.matches) displayText = "block";
    }
    this.state = {
      text1: "",
      itemShow: {
        item: null,
        isShow: isShow,
        displayText,
      },
    };
  }
  showRow = (item) => () => {
    let { itemShow } = this.state;
    let isShow = true;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches && !itemShow.isShow;
    }
    itemShow.item = item;
    itemShow.isShow = isShow;
    this.setState({ itemShow });
  };
  renderRow(List) {
    let { pageIndex, pageSize } = this.props;
    return List.map((item, index) => {
      let { Time, UserName, NoiDung, GhiChu, SoTien,Note } = item;
      return (
        <tr key={"lsGiaHanNoPhaThu" + index}>
          <td>{index + 1 + (pageIndex - 1) * pageSize}</td>
          <td>{getDate(Time)}</td>
          <td className="text-left">{UserName}</td>
          <td className="text-right">{formatNumber(SoTien)}</td>
          <td className="text-left">{NoiDung}</td>
          <td className="text-left">{Note}</td>
          <td className="text-left">{GhiChu}</td>
        </tr>
      );
    });
  }
  render() {
    let {
      List,
      pageIndex,
      pageSize,
      TotalQuantity,
      TongTien,
      handlePageChange,
    } = this.props;

    return (
      <div className="table-from-detailtl6">
        <div className="Left808x200  Table-main-morman table-noboder-new">
          <div className="table-responsive table-new1">
            <table className="table table-bordered table-hover table-rounded"  style={{marginTop:"20px"}}>
              <thead>
                <tr>
                <th className="w-stt"><span className="color-do-bold">[{TotalQuantity}]</span><br />&nbsp;</th>
                  <th className="w-10">Thời gian<br />&nbsp;</th>
                  <th className="w-15 text-left">Nhân viên<br />&nbsp;</th>
                  <th className="text-right w-15">
                    Số tiền
                    <br /> <i className="la la-dollar color-do-bold"></i>
                    <span className="red color-do-bold">={" "}{formatNumber(TongTien)}</span>
                  </th>
                  <th className="text-left">Nội dung<br />&nbsp;</th>
                  <th className="text-left">Ghi chú<br />&nbsp;</th>
                  <th className="text-left"></th>
                </tr>
              </thead>
              <tbody>{this.renderRow(List)}</tbody>
            </table>
          </div>
        </div>
        {TotalQuantity > pageSize && (
          <div className="footer-page-new">
            <div className="col-xl-12 col-lg-12">
              <div className="paniation-new d-flex just-end">
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={pageIndex}
                    itemsCountPerPage={pageSize}
                    totalItemsCount={TotalQuantity}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                     itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default LichSuHopDongView;
